import script from "./Head.vue?vue&type=script&setup=true&lang=js"
export * from "./Head.vue?vue&type=script&setup=true&lang=js"

import "./Head.vue?vue&type=style&index=0&id=2145a910&lang=scss"

const __exports__ = script;

export default __exports__